import { useNavigate } from 'react-router-dom';
import { Button, Layout, Result } from 'antd';
import { auth } from '@festpix/services';
import { colors } from '@festpix/ui';

const { Content } = Layout;

export default function AccessDeniedPage() {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await auth.signOut();
    navigate('/login');
  };

  return (
    <Layout style={{ minHeight: '100vh', background: colors.cardBackground }}>
      <Content
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 24,
        }}
      >
        <Result
          status="403"
          title="Acesso Negado"
          subTitle="Você não tem permissão para acessar esta área."
          extra={
            <Button type="primary" size="large" onClick={handleSignOut}>
              Sair e voltar ao início
            </Button>
          }
        />
      </Content>
    </Layout>
  );
}
